import { render, staticRenderFns } from "./FanOrFollowerListItem.vue?vue&type=template&id=3ca482b7&scoped=true&"
import script from "./FanOrFollowerListItem.vue?vue&type=script&lang=js&"
export * from "./FanOrFollowerListItem.vue?vue&type=script&lang=js&"
import style0 from "./FanOrFollowerListItem.vue?vue&type=style&index=0&id=3ca482b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca482b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMessages } from 'vuetify/lib/components/VMessages';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VMessages,VTextField})
